import { select, put, takeEvery, all, takeLatest } from 'redux-saga/effects';
import {
  setPostAcqTransientValuation,
  setPostAcqTransientValuationInputs,
  setPostAcqTransientValuationNotes,
  setPostAcqValuationIsDirty,
  setShouldCalculateProforma,
} from 'store/actions';
import { postAcqTransientValuationSelector, shouldCalculateProformaSelector, postAcqUWStateSelector, userSelector } from 'store/selectors';
import { isEqual } from 'lodash'

export function* setPostAcqTransientValuationSaga() {
  // NOTE: Updating transient valuation is done by reducer, here we just check to update dirty flag(s)
  yield takeEvery(setPostAcqTransientValuation, function* ({ payload }) {

    const { transientValuation, resetInputDirtyFlags = true, isUWModal } = payload;
    if (isUWModal) return;

    // Prep work
    const [user, postAcqUWState] = yield all([select(userSelector), select(postAcqUWStateSelector)]);
    const userPersistedValuation = postAcqUWState.selectedProformaInputsContainer?.valuations.find(val => val.user.id === user.id);

    // Need to reset shouldCalculateProforma flag when setTransientValuationSaga() is not triggered from valuation input change, namely not from setPostAcqTransientValuationInputs
    // One of the uses cases is when calculation result comes back from backend we need to reset need shouldCalculateProforma flag to remove the gray overlay over proforma output section
    if (resetInputDirtyFlags) {
      // yield all([put(setShouldCalculateProforma(false))]);
    }

    // Compare new transientValuation with userPersistedValuation to see if there is any difference changes - (changes include valuation input, output, comps selection or simply noBidReason)
    // One of the use cases is when calcuation result comes back from backend we need to check if we need to enable (with differences) or disable (no differences) 'Save' button
    if (userPersistedValuation) {
      const valuationIsDirty = !isEqual(transientValuation, userPersistedValuation);  // compare changes include all sections: input, output, nobidreason, notes
      yield put(setPostAcqValuationIsDirty(valuationIsDirty));
    }
  });

  /** This is a pipeline method in between valuation input changes and updating transient valuation.
  Its main purpose is to update shouldCalculateProforma flag */
  yield takeLatest(setPostAcqTransientValuationInputs, function* ({ payload }) {
    const { valuationInput, skipCalculate } = payload;
    // Prep work
    const [transientValuation, shouldCalculateProforma] = yield all([select(postAcqTransientValuationSelector), select(shouldCalculateProformaSelector)]);

    if (!skipCalculate && shouldCalculateProforma === false) {
      // yield put(setShouldCalculateProforma(true))
    }

    // Continue to update transientValuation
    const updatedTransientValuation = { ...transientValuation, valuationInput }
    yield put(setPostAcqTransientValuation(updatedTransientValuation, false)); // false is to tell the calling method to not reset shouldCalculateProforma flag
  });

  /**This is a pipeline method in between valuation notes change and updating transient valuation.
  Its main purpose is to not let setPostAcqTransientValuation reset shouldCalculateProforma flag */
  yield takeLatest(setPostAcqTransientValuationNotes, function* ({ payload: notes }) {
    // Prep work
    const transientValuation = yield select(postAcqTransientValuationSelector);

    // Continue to update transientValuation
    const updatedTransientValuation = { ...transientValuation, notes }
    yield put(setPostAcqTransientValuation(updatedTransientValuation, false)); // false is to tell the calling method to not reset shouldCalculateProforma flag
  });
}